import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from '../styles/modal.module.css';
import UserContext from '../context/user/UserContext';
import StateContext from '../context/state/StateContext';
import { toast } from 'react-toastify';
import Loading from './Loading';
import { IoSearch } from "react-icons/io5";
import Fuse from 'fuse.js';

const AddAgency = (props) => {
    const { getEmployees, getAgencyUsers, getAgencies } = useContext(UserContext);
    const { employees, setLoading, agencies, setAgencies, setModal, agencyUsers } = useContext(StateContext);
    const [drop, setDrop] = useState(Array(2).fill(false));
    const [assigned, setAssigned] = useState([]);
    const [disabled, setDisabled] = useState(true);
    const [agencyName, setAgencyName] = useState('');
    const [agencyType, setAgencyType] = useState('');
    const [agencyDescription, setAgencyDescription] = useState('')
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [hierarchy, setHierarchy] = useState('Manager'); // Default role
    const [error, setError] = useState(null);
    const [allEmployees, setAllEmployees] = useState(employees);
    const [filteredEmployees, setFilteredEmployees] = useState();
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        getEmployees(); // Fetch employees when component mounts
        getAgencyUsers()
        setFilteredEmployees(agencyUsers)
    }, []);
    const searchDropRef = useRef(null);
    const fuse = new Fuse(allEmployees && allEmployees, {
        keys: ['username'], // Search by the 'name' key
        threshold: 0.4, // Fuzzy match threshold (lower = stricter matches)
    });
    

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            setLoading({ open: true, text: "Adding Agency..." });
            if(assigned.length === 0){
                toast.warning("Please Select Agency Users")
                return
            }
            const response = await fetch(`${process.env.REACT_APP_API_URL}api/agency/create`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': `${localStorage.getItem('token')}`,
                },
                body: JSON.stringify({
                    name: agencyName,
                    type: agencyType,
                    description: agencyDescription,
                    userIds: assigned.map(user => user.id),
                }),
            });

            const result = await response.json();
            if (response.ok) {
                toast.success('Agency created successfully');
                setAgencyName('');
                setAgencyType('');
                setSelectedUsers([]);
                getAgencies()
                setModal({ open: false, component: "" });
            } else {
                setError(`Failed to create agency: ${result.message}`);
                toast.error(`Failed to create agency: ${result.message}`);
            }
        } catch (error) {
            console.error('Error creating Agency:', error);
            toast.error('Error creating Agency');
        } finally {
            setLoading({ open: false, text: "" });
        }
    };
    console.log(agencies)
    const handleUserSelection = (userId) => {
        setSelectedUsers((prevSelected) =>
            prevSelected.includes(userId)
                ? prevSelected.filter((id) => id !== userId)
                : [...prevSelected, userId]
        );
        setDisabled(false);
    };

    const assignedDrop = (id, username, action) => {
        const current = { id: id, username: username }
        if (action === 'add') {
            // Add the item to the assigned list
            setAssigned(prev => [...prev, { id, username }]);
        } else if (action === 'remove') {
            // Remove the item from the assigned list
            setAssigned(prev => prev.filter(item => item.username !== username));
        }
        setDisabled(false)
        // setDrop(false)
        setError('')
    }


    const handleSearch = (event) => {
        const query = event.target.value;
        setSearchQuery(query);

        if (query.trim() === '') {
            setFilteredEmployees(allEmployees);
        } else {
            const results = fuse.search(query);
            setFilteredEmployees(results.map(result => result.item));
        }
    };

    const handleDrop = (index) => {
        const array = [...drop]
        array[index] = !drop[index]
        setDrop(array)
    }

    return (
        <>
            <Loading />
            <div className={styles.head}>
                <h3>Add Agency</h3>
                <i className={`bx bx-x ${styles.close}`} onClick={() => props.close({ open: false, component: '' })}></i>
            </div>
            <form onSubmit={handleSubmit}>
                <div className={styles.form_container}>
                    <div className="row">
                        {/* Agency Name */}
                        <div className="inputField col-md-6">
                            <input
                                type="text"
                                id="agencyName"
                                value={agencyName}
                                placeholder="Add Agency Name"
                                onChange={(e) => { setAgencyName(e.target.value); setDisabled(false); }}
                                required
                            />
                        </div>

                        {/* Agency Type */}
                        <div className="inputField col-md-6">
                            <input
                                type="text"
                                id="agencyType"
                                value={agencyType}
                                placeholder="Add Agency Type (e.g., Electrical, IT, Cleaning)"
                                onChange={(e) => { setAgencyType(e.target.value); setDisabled(false); }}
                                required
                            />
                        </div>
                        {/* Agency Type */}
                        <div className="inputField col-md-6">
                            <input
                                type="text"
                                id="agencyDescription"
                                value={agencyDescription}
                                placeholder="Add Agency Description (e.g., Will usable for cleaning.)"
                                onChange={(e) => { setAgencyDescription(e.target.value); setDisabled(false); }}
                                required
                            />
                        </div>
                    </div>

                    {/* Select Users */}
                    {/* <div style={styles.formGroup}>
                        <label className='mb-1 label fw-semibold'>Select Users:</label>
                        <div style={styles.userList}>
                            {employees &&
                                employees.map((item, index) => (
                                    <div key={index} className="checkbox-wrapper-4">
                                        <input
                                            type="checkbox"
                                            checked={selectedUsers.includes(item.id)}
                                            onChange={() => handleUserSelection(item.id)}
                                            id={`user-${item.id}`}
                                            className="inp-cbx"
                                        />
                                        <label htmlFor={`user-${item.id}`} className="cbx">
                                            <span><svg></svg></span>
                                            <span className='text'>{item.name}</span>
                                        </label>
                                    </div>
                                ))}
                        </div>
                    </div> */}
                    <div className="col-md-6 col-12 pe-0">
                                <div
                                    className={`dropdown search-drop ${assigned.length > 0 ? 'drop2' : ''} ${drop[1] ? 'active' : ''}`}
                                    style={{ zIndex: '999' }}
                                >
                                    <div className="select" onClick={() => handleDrop(1)}>
                                        <div className="d-flex align-items-center overflow-hidden">
                                            {assigned && assigned.length > 0 ? (
                                                assigned.map((item, index) => (
                                                    <span
                                                        style={{
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            marginRight: '8px',
                                                            backgroundColor: '#f0f0f0',
                                                            padding: '4px 8px',
                                                            borderRadius: '4px',
                                                        }}
                                                        key={index}
                                                    >
                                                        {item.username}
                                                    </span>
                                                ))
                                            ) : (
                                                <span style={{ color: '#888' }}>Choose Members</span>
                                            )}
                                        </div>
                                        <i className="fa-solid fa-angle-up"></i>
                                    </div>
                                    <ul>
                                        <div className="drop-input">
                                            <IoSearch />
                                            <input
                                                type="text"
                                                name="employees"
                                                placeholder="Search Members..."
                                                ref={searchDropRef}
                                                value={searchQuery}
                                                onChange={handleSearch}
                                            />
                                        </div>
                                        <div className="list">
                                            {agencyUsers && agencyUsers.length > 0 ? (
                                                agencyUsers.map((item, index) => (
                                                    <li key={index}>
                                                        <label
                                                            htmlFor={`employee-${index}`}
                                                            className="d-flex align-items-center"
                                                            style={{ gap: '10px', cursor: 'pointer' }}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                id={`employee-${index}`}
                                                                checked={assigned.some((assignedItem) => assignedItem.username === item.username)}
                                                                onChange={() => {
                                                                    if (assigned.some((assignedItem) => assignedItem.username === item.username)) {
                                                                        assignedDrop(item.id, item.username, 'remove');
                                                                    } else {
                                                                        assignedDrop(item.id, item.username, 'add');
                                                                    }
                                                                }}
                                                            />
                                                            <span>{item.username}</span>
                                                        </label>
                                                    </li>
                                                ))
                                            ) : (
                                                <div style={{ padding: '8px', color: '#888' }} className='d-flex align-items-center justify-content-center h-100 w-100'>No employees found</div>
                                            )}
                                        </div>
                                    </ul>
                                </div>
                            </div>
                </div>

                {/* Form Actions */}
                <div className={styles.foot}>
                    <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                        <button type="button" className="button2 cancel" onClick={() => props.close({ open: false, component: '' })}>Cancel</button>
                        <button type="submit" className={`button2 ${disabled ? 'disabled' : ''}`} disabled={disabled}>Add</button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default AddAgency;
